import React from 'react';

export const ArrowLeftIcon = (props) => {
    const { color, size } = props;

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 20 20">
            <g transform="translate(432 -261) rotate(90)">
                <rect className="a" fill="none" width="20" height="20" transform="translate(261 412)" />
                <path
                    className="b"
                    fill="none"
                    stroke={color}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.5px"
                    d="M158.476,424.278l6.737-7,6.263,7"
                    transform="translate(435.976 842.778) rotate(180)"
                />
            </g>
        </svg>
    );
};

export const ArrowUpIcon = (props) => {
    const { color, size } = props;

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 20 20">
            <g transform="translate(281 432) rotate(180)">
                <rect className="a" fill="none" width="20" height="20" transform="translate(261 412)" />
                <path
                    className="b"
                    fill="none"
                    stroke={color}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.5px"
                    d="M158.476,424.278l6.737-7,6.263,7"
                    transform="translate(435.976 842.778) rotate(180)"
                />
            </g>
        </svg>
    );
};

export const ArrowRightIcon = (props) => {
    const { color, size } = props;

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 20 20">
            <g transform="translate(-412 281) rotate(-90)">
                <rect className="a" fill="none" width="20" height="20" transform="translate(261 412)" />
                <path
                    className="b"
                    fill="none"
                    stroke={color}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.5px"
                    d="M158.476,424.278l6.737-7,6.263,7"
                    transform="translate(435.976 842.778) rotate(180)"
                />
            </g>
        </svg>
    );
};

export const ArrowDownIcon = (props) => {
    const { color, size } = props;

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 20 20">
            <rect fill="none" width="20" height="20" />
            <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5px"
                fill="none"
                stroke={color}
                d="M158.476,424.278l6.737-7,6.263,7"
                transform="translate(174.976 430.778) rotate(180)"
            />
        </svg>
    );
};

export const CheckCircleIcon = (props) => {
    const { color, size } = props;
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 32 32">
            <path
                className="a"
                fill={color}
                d="M-3021-1356a16.017,16.017,0,0,1-16-16,16.018,16.018,0,0,1,16-16,16.019,16.019,0,0,1,16,16A16.018,16.018,0,0,1-3021-1356Zm-6.185-17.055a1.24,1.24,0,0,0-.883.367,1.243,1.243,0,0,0-.366.883,1.243,1.243,0,0,0,.366.884l3.993,3.993a1.234,1.234,0,0,0,.884.366,1.24,1.24,0,0,0,.883-.366l3.055-3.055,5.326-5.326a1.243,1.243,0,0,0,.368-.885,1.242,1.242,0,0,0-.368-.885,1.239,1.239,0,0,0-.883-.366,1.242,1.242,0,0,0-.879.362l-7.5,7.5-3.11-3.108A1.241,1.241,0,0,0-3027.186-1373.055Z"
                transform="translate(3037 1388)"
            />
        </svg>
    );
};

export const ErrorIcon = (props) => {
    const { color, size } = props;

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 32 32">
            <path
                className="a"
                fill={color}
                d="M-2875-927a15.9,15.9,0,0,1-11.314-4.686A15.9,15.9,0,0,1-2891-943a15.9,15.9,0,0,1,4.686-11.314A15.9,15.9,0,0,1-2875-959a15.894,15.894,0,0,1,11.313,4.687A15.9,15.9,0,0,1-2859-943a15.9,15.9,0,0,1-4.686,11.314A15.9,15.9,0,0,1-2875-927Zm0-14.381h0l4.045,4.047a1.137,1.137,0,0,0,.81.335,1.137,1.137,0,0,0,.809-.335,1.148,1.148,0,0,0,0-1.619l-4.047-4.046,4.047-4.046a1.137,1.137,0,0,0,.335-.809,1.135,1.135,0,0,0-.335-.809,1.139,1.139,0,0,0-.81-.335,1.139,1.139,0,0,0-.81.335l-4.046,4.046-4.046-4.046a1.137,1.137,0,0,0-.809-.335,1.135,1.135,0,0,0-.809.335,1.135,1.135,0,0,0-.335.809,1.137,1.137,0,0,0,.335.809l4.046,4.046-4.045,4.046a1.136,1.136,0,0,0-.335.808,1.137,1.137,0,0,0,.335.81,1.137,1.137,0,0,0,.81.336,1.143,1.143,0,0,0,.809-.336l4.044-4.045Z"
                transform="translate(2891 959)"
            />
        </svg>
    );
};

export const StatusCircleIcon = (props) => {
    const { color, size } = props;

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 32 32">
            <path
                className="a"
                fill={color}
                d="M16,32A16,16,0,1,1,32,16,16.018,16.018,0,0,1,16,32ZM14.587,12.2V24H17.4V12.2Zm0-4.125v2.406h2.826V8.07Z"
            />
        </svg>
    );
};

export const StatusTriangleIcon = (props) => {
    const { color, size } = props;

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 32 32">
            <rect className="a" fill="none" width="32" height="32" transform="translate(0)" />
            <g transform="translate(0 2)">
                <g transform="translate(0 0)">
                    <path
                        className="b"
                        fill={color}
                        d="M31.718,63.19,17.679,39.336a1.937,1.937,0,0,0-3.358,0L.282,63.19a2.051,2.051,0,0,0-.028,2.025,1.953,1.953,0,0,0,1.707,1.021H30.039a1.953,1.953,0,0,0,1.707-1.021A2.051,2.051,0,0,0,31.718,63.19ZM16.011,46.616A1.339,1.339,0,0,1,17.5,47.908c0,2.52-.289,6.142-.289,8.663,0,.657-.7.932-1.2.932-.662,0-1.22-.275-1.22-.932,0-2.52-.289-6.142-.289-8.663A1.336,1.336,0,0,1,16.011,46.616Zm.021,15.61A1.632,1.632,0,1,1,17.6,60.6,1.637,1.637,0,0,1,16.031,62.227Z"
                        transform="translate(0 -38.365)"
                    />
                </g>
            </g>
        </svg>
    );
};

export const CircleIcon = (props) => {
    const { color, size } = props;

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size}>
            <rect className="a" fill="none" width="32" height="32" transform="translate(0)" />
            <g transform="translate(0 2)">
                <g transform="translate(0 0)">
                    <circle cx="16" cy="14" r="14" stroke={color} strokeWidth="3" fill="none" />
                </g>
            </g>
        </svg>
    );
};
